<template>
  <div>
    <span class="font-weight-light text-h5">Building information</span>
    <v-row class="mt-3">
      <v-col sm="6" md="6" lg="6">
        <div class="info-item">
          <label>Address:</label><br />
          <span
            >{{ buildingData.functional_unit.address_data.street }}
            {{ buildingData.functional_unit.address_data.street_number }},<br />
            {{ buildingData.functional_unit.address_data.postal_code }}
            {{ buildingData.functional_unit.address_data.city }},
            {{ buildingData.functional_unit.address_data.country }}</span
          >
        </div>
        <div class="info-item">
          <label>Year of Construction:</label><br />
          <span>{{ buildingData.functional_unit.year_of_construction }}</span>
        </div>
        <div class="info-item">
          <label>Latest renovation Year:</label><br />
          <span>{{ buildingData.functional_unit.renovation_year }}</span>
        </div>
        <div class="info-item">
          <label>Floor Area:</label><br />
          <span>{{ buildingData.functional_unit.floor_area }}</span>
        </div>
        <div class="info-item">
          <label>Certifiable:</label><br />
          <span>{{ buildingData.functional_unit.certifiable }}</span>
        </div>
        <div class="info-item">
          <label>Description:</label><br />
          <span>{{ buildingData.functional_unit.description }}</span>
        </div>
      </v-col>
      <v-col sm="6" md="6" lg="6">
        <div class="info-item">
          <label>Functional Unit Type:</label><br />
          <span>{{ fUnitType }}</span>
        </div>
        <div class="info-item">
          <label>Building Type Usage:</label><br />
          <span>{{ fUnitTypeUsage }}</span>
        </div>

        <div class="info-item">
          <label>Floor:</label><br />
          <span>{{ buildingData.functional_unit.floor }}</span>
        </div>
        <div class="info-item">
          <label>Door Number:</label><br />
          <span>{{ buildingData.functional_unit.door_number }}</span>
        </div>
        <div class="info-item">
          <label>Room:</label><br />
          <span>{{ buildingData.functional_unit.room }}</span>
        </div>
        <div class="info-item">
          <label>Name:</label><br />
          <span>{{ buildingData.functional_unit.name }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import utility from "../utility/utility";
export default {
  name: "BuildingInfoPanel",
  components: {},
  data() {
    return {};
  },
  props: {
    buildingData: {
      type: Object,
      required: true,
    },
  },
  methods: {},

  computed: {
    fUnitType: function () {
      return utility.convertStrToLabel(
        this.buildingData.functional_unit.functional_unit_type
      );
    },
    fUnitTypeUsage: function () {
      return utility.convertStrToLabel(
        this.buildingData.functional_unit.building_type_usage
      );
    },
  },
};
</script>

<style scoped>
.info-item {
  margin-bottom: 10px;
  text-align: left;
}
.info-item label {
  font-weight: bold;
  font-size: 1em;
}
.info-item span {
  font-size: 1em;
}
.label {
  font-weight: bold;
}
</style>
